const CityWiseId = {
  Kochi: 46594844,
  Shimoga: 46594865,
  Udupi: 46594859,
  Kolkata: 46594837,
  Mangaluru: 46594848,
  Indore: 46594857,
  Jabalpur: 46594862,
  Bhopal: 46594861,
  Patna: 46594852,
  Bhubaneswar: 46594851,
  Hubli: 46594860,
  Guwahati: 46594843,
  Davanagere: 46594868,
  Belgaum: 46594855,
  Chitradurga: 20,
  Mumbai: 17,
  "N/A": "N/A",
};

const IdWiseCity = {
  46594844: "Kochi",
  46594865: "Shimoga",
  46594859: "Udupi",
  46594837: "Kolkata",
  46594848: "Mangaluru",
  46594857: "Indore",
  46594862: "Jabalpur",
  46594861: "Bhopal",
  46594852: "Patna",
  46594851: "Bhubaneswar",
  46594860: "Hubli",
  46594843: "Guwahati",
  46594868: "Davanagere",
  46594855: "Belgaum",
  20: "Chitradurga",
  17: "Mumbai",
  "N/A": "N/A",
};

const roles = {
  cityManager: "CityManager",
  admin: "Admin",
  operator: "Operator",
  agencyManager: "AgencyManager",
  finance: "Finance",
  superAdmin: "Superadmin",
};

export { CityWiseId, IdWiseCity, roles };
